import { Component, OnInit, Input, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationServices } from '../../../appauth/notification/notificatio.services';
import { CustomValidators } from 'ng2-validation';
import { FotoRecepcionistasServices } from '../fotorecepcionista/fotorecepcionistas.services';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
	selector: 'app-add-foto-recepcionista',
	templateUrl: './fotorecepcionista.compente.html',
	styleUrls: ['./fotorecepcionista.compente.scss']
})

export class FotoRecepcionistasComponent implements OnInit {
    
	constructor(private fb: FormBuilder,
        private servicioFotoRecepcionistas:FotoRecepcionistasServices,
        public dialogRef: MatDialogRef <FotoRecepcionistasComponent>,
        @Inject(MAT_DIALOG_DATA) public Recepcionista: any,
		private Noti:NotificationServices,) { }

	ngOnInit() {
		console.log(this.Recepcionista);
        
	}


	onFileChange(event) {
    if(event.target.files.length > 0) {
        var file = event.target.files[0];
        var formData = new FormData();
        
        formData.append('filename', file);
        formData.append('recepcionista_id',this.Recepcionista.id);
        
        this.servicioFotoRecepcionistas.saveFotoRecepcionista(formData).subscribe((data:any)=>{
        if(data.estado){
            this.Noti.setNotification(data).then((datas)=>{
                if(datas){
                    this.dialogRef.close(1);
                }
            }); 
            
        }else{
            this.Noti.setNotification(data);
        }
        });
    }
    }

}